<div class="welcome-onboarding-root" *transloco="let t">
  <div class="text">{{ t('landing-text') }}</div>
  <button
    mat-button-create
    id="landing-create"
    [routerLink]="'/'+RouterKeys.REGISTER"
  >
    {{ t('landing-button-create') }}
  </button>
</div>
